import { GetReleaseReq } from "@/pbjs/external/config/config_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { configClient } from "@/api/ConfigClient";
import { setMetaData } from "@/utils";
// import router from '@/router'
//  lee  获取角色分类
interface ITicketLogReq {
  pageIndex: number;
  pageSize: number;
  ItemKey: string;
  ItemComment: string;
  Operator: string;
}
export function getRelease(arg: ITicketLogReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request = new GetReleaseReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setItemkey(arg.ItemKey);
      request.setItemcomment(arg.ItemComment);
      request.setOperator(arg.Operator);
      await configClient.getRelease(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
